import axiosConfig from "./axiosConfig";

export interface LeadResearchCostTotals {
  runCount: number;
  testRunCount: number;
  modelUsd: number;
  webSearchUsd: number;
  totalUsd: number;
  webSearchCount: number;
}

export interface LeadResearchCostRun {
  id: string;
  createdAt: string;
  // The trace subject ref (prompt-test:<ref> for a test run, the raw ref for a
  // live run) - also the first half of the trace lookup key.
  subjectRef: string | null;
  isTest: boolean;
  failed: boolean;
  webSearchCount: number;
  modelUsd: number;
  webSearchUsd: number;
  totalUsd: number;
  traceSubjectRef: string | null;
  traceRunId: string | null;
}

export interface LeadResearchCostsResponse {
  windowDays: number;
  generatedAt: string;
  // Costs are ESTIMATES computed from per-model token + web-search counts on read.
  webSearchUsdPerQuery: number;
  totals: LeadResearchCostTotals;
  recent: LeadResearchCostRun[];
  truncated: boolean;
}

const getLeadResearchCosts = async (
  authToken: string,
  days: number
): Promise<LeadResearchCostsResponse> => {
  const { data } = await axiosConfig.get(`/leads/research-costs`, {
    params: { days },
    headers: { Authorization: `Bearer ${authToken}` },
  });
  return data;
};

export default getLeadResearchCosts;
